import {Layout as AntLayout} from 'antd'

const {Footer, Content, Sider} = AntLayout

export {Layout} from './layout'
export {Header} from './header/header'
export {Footer, Content, Sider}
